import styled from 'styled-components';

import {grey} from '@drivesally/sally-ui/lib/libs/colors';

const MembersContainer = styled.div`
  border-left: 1px solid ${grey};
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

export default MembersContainer;
